import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];
const sanitise = ({id, eventId, templateId, ...rest}) => ({
    id: Number(id) || null,
    eventId: Number(eventId) || null,
    templateId: Number(templateId) || null,
    ...rest
});

const EventReminderStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _entities.filter(function(e) { return e !== undefined; } );
    },
    getByEvent: function(eventId) {
        return _entities.filter(function(e) { return e !== undefined && e.eventId == eventId; } );
    },
    get(id) {
        return _entities.find(e => !!e && (e.id === id));
    },
    add: function(reminder) {
        if (reminder && reminder.id && reminder.eventId) {
            const index = _entities.findIndex((e) => (e !== undefined && (e.id === reminder.id)) );
            if (0 <= index) {
                _entities[index] = reminder;
            } else {
                _entities.push(reminder);
            }
        }
    },
    remove: function(data) {
        if (!data || !data.id) { return false; }

        const id = Number(data.id);
        const index = _entities.findIndex(function(e) { return e !== undefined && e.id === id; });
        if (0 <= index) {
            if (data.deleted) {
                delete _entities[index];
            } else {
                _entities[index].loading = false;
            }
        }
        return (0 <= index);
    }
});


EventReminderStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.EVENT_REMINDER_LIST:
            action.data.forEach(data => EventReminderStore.add(sanitise(data)));
            EventReminderStore.emitChange();
            break;

        case ActionTypes.EVENT_REMINDER_INFO_SUCCESS:
            EventReminderStore.add(sanitise(action.data));
            EventReminderStore.emitChange();
            break;

        case ActionTypes.EVENT_REMINDER_INFO_FAILURE:
            EventReminderStore.remove(action.payload);
            EventReminderStore.emitChange();
            break;
            
        case ActionTypes.EVENT_REMINDER_REMOVE:
            EventReminderStore.remove(action.data);
            EventReminderStore.emitChange();
            break;

        case ActionTypes.EVENT_REMINDER_SAVE:
            EventReminderStore.add(sanitise(action.data));
            EventReminderStore.emitChange();
            break;
            
        
        // Common error handling:
        case ActionTypes.EVENT_REMINDER_LIST_ERROR:
        case ActionTypes.EVENT_REMINDER_SAVE_ERROR:
            EventReminderStore.emitChange();
            break;
            
        default:
            break;
    }
});

export default EventReminderStore;
